/* unplugin-vue-components disabled */import { render } from "./KilaKilaAdminCard.vue?vue&type=template&id=3b3a5ff4&scoped=true"
import script from "./KilaKilaAdminCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaAdminCard.vue?vue&type=script&lang=js"

import "./KilaKilaAdminCard.vue?vue&type=style&index=0&id=3b3a5ff4&scoped=true&lang=css"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3a5ff4"]])

export default __exports__